var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "fullscreen",
          attrs: {
            onclick:
              "document.querySelector('body').webkitRequestFullscreen();this.remove()",
          },
        },
        [_vm._v("Fullscreen")]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "wrapper wrapper--tablet" }, [
        _c("section", { staticClass: "control" }, [
          _c("div", { staticClass: "control__section control__section--new" }, [
            _c("h2", {
              domProps: { innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_NEW")) },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control__grid control__scroll" },
              _vm._l(_vm.newOrderList, function (order) {
                return _c("OrderBox", {
                  key: order.id,
                  attrs: { order: order },
                  on: {
                    edit: function ($event) {
                      return _vm.onOrderEdit(order)
                    },
                    click: function ($event) {
                      return _vm.onOrderAdvance(order)
                    },
                  },
                })
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control__section control__section--preparation" },
            [
              _c("h2", {
                domProps: {
                  innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_PREP")),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "control__grid control__scroll control__scroll--high",
                },
                _vm._l(_vm.prepOnlyOrderList, function (order) {
                  return _c("OrderBox", {
                    key: order.id,
                    attrs: { order: order },
                    on: {
                      edit: function ($event) {
                        return _vm.onOrderEdit(order)
                      },
                      click: function ($event) {
                        return _vm.onOrderAdvance(order)
                      },
                    },
                  })
                }),
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasFeature("FEATURE_ORDERBOXES") &&
          _vm.hasFeature("FEATURE_PREPAREBOXES")
            ? _c(
                "div",
                { staticClass: "control__section control__section--pick-up" },
                [
                  _c("h2", {
                    domProps: {
                      innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_PREP_BOX")),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "control__grid control__grid--pick-up control__scroll",
                      class: [`control__grid--cols-${_vm.boxColumns}`],
                    },
                    _vm._l(_vm.prepareOrderList, function (order) {
                      return _c("OrderBox", {
                        key: order.box,
                        attrs: { order: order },
                        on: {
                          edit: function ($event) {
                            return _vm.onOrderEdit(order)
                          },
                          click: function ($event) {
                            return _vm.onOrderAdvance(order)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control__section control__section--pick-up" },
            [
              _c("h2", {
                domProps: {
                  innerHTML: _vm._s(_vm.langValue("LANG_ORDERS_PICKUP")),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control__grid control__scroll",
                  class: [
                    _vm.hasFeature("FEATURE_ORDERBOXES")
                      ? `control__grid--cols-${_vm.boxColumns}`
                      : "",
                    {
                      "control__grid--pick-up":
                        _vm.hasFeature("FEATURE_ORDERBOXES"),
                    },
                  ],
                },
                [
                  _vm.hasFeature("FEATURE_ORDERBOXES")
                    ? _vm._l(_vm.pickupOrderBoxList, function (order) {
                        return _c("OrderBox", {
                          key: order.box,
                          attrs: { order: order },
                          on: {
                            edit: function ($event) {
                              return _vm.onOrderEdit(order)
                            },
                            click: function ($event) {
                              return _vm.onOrderAdvance(order)
                            },
                          },
                        })
                      })
                    : _vm._l(_vm.pickupOrderList, function (order) {
                        return _c("OrderBox", {
                          key: order.id,
                          attrs: { order: order },
                          on: {
                            edit: function ($event) {
                              return _vm.onOrderEdit(order)
                            },
                            click: function ($event) {
                              return _vm.onOrderAdvance(order)
                            },
                          },
                        })
                      }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.hasFeature("FEATURE_PASTORDERS")
            ? _c(
                "button",
                {
                  staticClass: "control__past-orders-button",
                  attrs: { type: "button" },
                  on: { click: _vm.onPastOrdersOpen },
                },
                [_vm._v("Past Orders")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_PASTORDERS")
        ? _c("OverlayPastOrders", {
            attrs: { list: _vm.pastOrderList },
            on: {
              changestate: _vm.onPastOrderEdit,
              close: _vm.overlayPastClose,
            },
            model: {
              value: _vm.overlayPastOpen,
              callback: function ($$v) {
                _vm.overlayPastOpen = $$v
              },
              expression: "overlayPastOpen",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("OverlayOrderUpdate", {
        attrs: {
          order: _vm.overlayOrder,
          currentPickups: _vm.pickupOrderBoxList,
          currentPrepare: _vm.prepareOrderList,
          "box-columns": _vm.boxColumns,
        },
        on: { changestate: _vm.onOverlaySelect },
        model: {
          value: _vm.overlayOpen,
          callback: function ($$v) {
            _vm.overlayOpen = $$v
          },
          expression: "overlayOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }